/**
 * @generated SignedSource<<4b9a94064cfc43c0b250733bf8b63c8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NewPlan = "PROMO" | "UP_TO_100" | "UP_TO_200" | "UP_TO_50" | "UP_TO_UNLIMITED" | "YEARLY_UNLIMITED" | "YEARLY_UP_TO_100" | "YEARLY_UP_TO_200" | "YEARLY_UP_TO_50" | "%future added value";
export type UpdateUserSubscriptionInput = {
  clientMutationId?: string | null | undefined;
  plan: NewPlan;
};
export type ProUpgradeCardUpdateSubsMutation$variables = {
  input: UpdateUserSubscriptionInput;
};
export type ProUpgradeCardUpdateSubsMutation$data = {
  readonly updateUserSubscription: {
    readonly status: string | null | undefined;
  } | null | undefined;
};
export type ProUpgradeCardUpdateSubsMutation = {
  response: ProUpgradeCardUpdateSubsMutation$data;
  variables: ProUpgradeCardUpdateSubsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserSubscriptionPayload",
    "kind": "LinkedField",
    "name": "updateUserSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProUpgradeCardUpdateSubsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProUpgradeCardUpdateSubsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0afd5cf7681df88f857ce70e463462d5",
    "id": null,
    "metadata": {},
    "name": "ProUpgradeCardUpdateSubsMutation",
    "operationKind": "mutation",
    "text": "mutation ProUpgradeCardUpdateSubsMutation(\n  $input: UpdateUserSubscriptionInput!\n) {\n  updateUserSubscription(input: $input) {\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ec3b379d619e2f92a207d000c1cbf24";

export default node;
